import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum HospiceRacesEnum {
    none = 0 as number,
    White = 1 as number,
    BlackOrAfricanAmerican = 2 as number,
    AmericanIndianOrAlaskanNative = 4 as number,
    AsianIndian = 8 as number,
    Chinese = 16 as number,
    Filipino = 32 as number,
    Japanese = 64 as number,
    Korean = 128 as number,
    Vietnamese = 256 as number,
    OtherAsian = 512 as number,
    NativeHawaiian = 1024 as number,
    GuamanianOrChamorro = 2048 as number,
    Samoan = 4096 as number,
    OtherPacificIslander = 8192 as number,
    PatientUnableToRespond = (1 << 23) as number,
    PatientDeclinesToRespond = (1 << 24) as number,
    NoneOfTheAbove = (1 << 25) as number
}
class HospiceRacesClass extends EnumWithDescription<HospiceRacesEnum> {
    public readonly enum = HospiceRacesEnum;
    public readonly enumName: string = "HospiceRacesEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HospiceRacesEnum>> = new Map([
        [
            "White",
            {
                value: HospiceRacesEnum.White,
                name: "A. White"
            }
        ],
        [
            "BlackOrAfricanAmerican",
            {
                value: HospiceRacesEnum.BlackOrAfricanAmerican,
                name: "B. Black or African American"
            }
        ],
        [
            "AmericanIndianOrAlaskanNative",
            {
                value: HospiceRacesEnum.AmericanIndianOrAlaskanNative,
                name: "C. American Indian or Alaskan Native"
            }
        ],
        [
            "AsianIndian",
            {
                value: HospiceRacesEnum.AsianIndian,
                name: "D. Asian Indian"
            }
        ],
        [
            "Chinese",
            {
                value: HospiceRacesEnum.Chinese,
                name: "E. Chinese"
            }
        ],
        [
            "Filipino",
            {
                value: HospiceRacesEnum.Filipino,
                name: "F. Filipino"
            }
        ],
        [
            "Japanese",
            {
                value: HospiceRacesEnum.Japanese,
                name: "G. Japanese"
            }
        ],
        [
            "Korean",
            {
                value: HospiceRacesEnum.Korean,
                name: "H. Korean"
            }
        ],
        [
            "Vietnamese",
            {
                value: HospiceRacesEnum.Vietnamese,
                name: "I. Vietnamese"
            }
        ],
        [
            "OtherAsian",
            {
                value: HospiceRacesEnum.OtherAsian,
                name: "J. Other Asian"
            }
        ],
        [
            "NativeHawaiian",
            {
                value: HospiceRacesEnum.NativeHawaiian,
                name: "K. Native Hawaiian"
            }
        ],
        [
            "GuamanianOrChamorro",
            {
                value: HospiceRacesEnum.GuamanianOrChamorro,
                name: "L. Guamanian or Chamorro"
            }
        ],
        [
            "Samoan",
            {
                value: HospiceRacesEnum.Samoan,
                name: "M. Samoan"
            }
        ],
        [
            "OtherPacificIslander",
            {
                value: HospiceRacesEnum.OtherPacificIslander,
                name: "N. Other Pacific Islander"
            }
        ],
        [
            "PatientUnableToRespond",
            {
                value: HospiceRacesEnum.PatientUnableToRespond,
                name: "X. Patient unable to respond"
            }
        ],
        [
            "PatientDeclinesToRespond",
            {
                value: HospiceRacesEnum.PatientDeclinesToRespond,
                name: "Y. Patient declines to respond"
            }
        ],
        [
            "NoneOfTheAbove",
            {
                value: HospiceRacesEnum.NoneOfTheAbove,
                name: "Z. None of the above"
            }
        ]
    ]);
}

export const HospiceRaces = new HospiceRacesClass();
